const APP_HOMES = Object.freeze({
    sales: "/home/index",
    delivery: "/home/delivery/overview",
    files: "/home/file",
});

const DEFAULT_APP_ID = "sales";
const STORAGE_KEY = "ruleasyCurrentApp";

export const normalizeAppId = (value) => Object.prototype.hasOwnProperty.call(APP_HOMES, value) ? value : DEFAULT_APP_ID;

export const getLastAppId = () => normalizeAppId(window.localStorage?.getItem(STORAGE_KEY));

export const getLastAppHome = () => APP_HOMES[getLastAppId()];

export const rememberApp = (appId) => {
    const normalized = normalizeAppId(appId);
    window.localStorage?.setItem(STORAGE_KEY, normalized);
    return normalized;
};

export const resolveAppFromRoute = (path, currentAppId = getLastAppId()) => {
    const normalizedCurrent = normalizeAppId(currentAppId);
    if (path === "/home/delivery" || path.startsWith("/home/delivery/")) return "delivery";
    if (path === "/home/file" || path.startsWith("/home/file/")) {
        return normalizedCurrent === "delivery" ? "delivery" : "files";
    }
    if (path === "/home/task" || path.startsWith("/home/task/")) {
        return normalizedCurrent === "delivery" ? "delivery" : "sales";
    }
    if (["/home/index", "/home/lead", "/home/account", "/home/opportunity", "/home/quote", "/home/contract", "/home/approval-inbox", "/home/report"]
        .some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) return "sales";
    return normalizedCurrent;
};

export const appHome = (appId) => APP_HOMES[normalizeAppId(appId)];
